var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var CrossIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 42,
    glyphHeight: 42
  }), React.createElement("path", {
    d: "M41.6609 35.7545L26.9061 20.9997L41.6609 6.24495L35.7548 0.338867L21 15.0936L6.2452 0.338867L0.339111 6.24495L15.0939 20.9997L0.339111 35.7545L6.2452 41.6606L21 26.9058L35.7548 41.6606L41.6609 35.7545Z"
  }));
};
export var CrossIconGlyph = function (props) {
  return React.createElement(CrossIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};